import React, { Component } from 'react'
import { Table, Row, Col } from 'antd';
import { convertDate, convertPendingFor } from './utils'
import { lineitemStates, pendingStates, pendingQaStates } from '../../../lib/util'
import { getCurrentUserEmail } from '../../auth/components/util'
import Filter from './Filter'
import Toast from '../../../components/Toast'
import SearchSelect from '../../../components/SearchSelect'
import StatusSymbol from '../../../components/StatusSymbol'
import PopOver from '../../../components/PopOver';
import * as nav from '../../../lib/nav'

const columns = [
  {
    title: '',
    dataIndex: 'state',
    key: 'status',
    width: 14,
    render: (state, row) => <StatusSymbol status={state} qaState={row.qaState}  nolabel/>
  },
  {
    title: 'LineItem',
    dataIndex: 'title',
    key: 'title',
    sorter: true,
    width: 200,
    render: (title, row) => (
      <div>
        {title}<br/> 
        <span className='id'>{row.extLineItemId}</span>
      </div>
    )
  },
  {
    title: 'Project',
    dataIndex: 'projectTitle',
    key: 'projectTitle',
    sorter: true,
    render: (projectTitle, row) => {
      const { extProjectId, lineitems } = row
      return (
        <Row type="flex">
          {lineitems.length > 0 &&
            <Col span={2} className="round-cont">
              <PopOver lineitems={lineitems}/>
            </Col>
          }
          <Col>
            {projectTitle} <br/> <span className='id'>{extProjectId}</span>
          </Col>
        </Row>
      )
    }
  },
  {
    title: 'Company Name',
    dataIndex: 'company.name',
    key: 'company',
    sorter: true,
  },
  {
    title: 'LOI',
    dataIndex: 'lengthOfInterview',
    key: 'lengthOfInterview',
    sorter: true,
  },
  {
    title: 'Created',
    dataIndex: 'createdAt',
    key: 'createdAt',
    sorter: true,
    render: (createdAt, row) => { 
      const pendingFor = convertPendingFor(row.pendingFor);
      const state = row.state.toLowerCase();
      const qaState = row.qaState.toLowerCase();
      return (
        <div>
          {createdAt && convertDate(createdAt)}<br/> 
          {pendingStates.includes(state) && pendingQaStates.includes(qaState) && <span className='id'>Pending for {pendingFor}</span>}
        </div>
      )
    }
  },
  {
    title: 'Assigned User',
    dataIndex: 'user.assignedTo',
    key: 'assignedTo',
    sorter: true
  }
];

class Lineitems extends Component {

  constructor(){
    super()
    this.state = {
      selectedRow: {},
      columns,
    };
    this.onTableCellClick = this.onTableCellClick.bind(this);
    this.handleUserChange = this.handleUserChange.bind(this);
    this.renderAssignedUser = this.renderAssignedUser.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { viewState, lineitems } = nextProps
    const { sortField, sortOrder } = this.state;

    if(viewState === "USERS_DID_LOAD")
      this.props.actions.loadLineitems({qaState: "PRE_APPROVE,PRE_APPROVED,POST_APPROVED", state: "LAUNCHED,AWAITING_APPROVAL"})
    
    if(viewState === "LINEITEMS_DID_LOAD") {
      lineitems.forEach(l => 
        this.props.actions.loadLineitemsByProjectId(
          { extProjectId: l.extProjectId, state: lineitemStates}
        )
      )
      columns.forEach(col => {
        col.sortOrder = sortField === col.dataIndex ? sortOrder : false
        col.title === "Assigned User"
          ? col.render = (assignedTo, row) => this.renderAssignedUser(assignedTo, row)
          : col.onCell = (row) => { return { onClick: () => this.onTableCellClick(row) } }
      })
      this.setState({columns})
    }
  }

  componentDidMount(){
    this.props.actions.loadUsers()
  }

  onPageChange = (pagination, filters, sorter) => {
    const { pageSize, current } = pagination;
    const { field, order } = sorter;
    const { limit, actions, filter } = this.props;
    this.setState({
      sortField: field,
      sortOrder: order
    });
    let qaState =''
    if (filter.selectedState === 'LAUNCHED,AWAITING_APPROVAL') {
      qaState='PRE_APPROVE,PRE_APPROVED,POST_APPROVED'
    }
    actions.loadLineitems({
      offset: pageSize * current - pageSize,
      limit: pageSize,
      state: filter.selectedState,
      qaState: qaState,
      sort: `${field}:${order === 'ascend' ? 'asc' : 'desc'}`
    })
    actions.setLimitOffsetSort({
      limit, 
      offset: pageSize * current - pageSize, 
      sort: `${field}:${order === 'ascend' ? 'asc' : 'desc'}`
    })
  };
  
  onPageSizeChange = (pageSize) => {
    const { selectedState } = this.props.filter;
    const { offset, actions } = this.props;
    const { sortField, sortOrder } = this.state;
    let qaState =''
    if (selectedState === 'LAUNCHED,AWAITING_APPROVAL') {
      qaState='PRE_APPROVE,PRE_APPROVED,POST_APPROVED'
    }
    actions.loadLineitems({
      size: pageSize,
      state: selectedState,
      qaState: qaState,
      sort: `${sortField}:${sortOrder === 'ascend' ? 'asc' : 'desc'}`,
      offset
    })
    actions.setLimitOffsetSort({
      limit: pageSize, 
      offset, 
      sort: `${sortField}:${sortOrder === 'ascend' ? 'asc' : 'desc'}`
    })
  }

  renderAssignedUser = (assignedTo, row) => {
    const { users } = this.props;
    const currentUserEmail = getCurrentUserEmail()
    const value = assignedTo === '' ? 'assignme' : assignedTo

    return (
      <SearchSelect 
        lineItemUUID={row.lineItemUUID}
        value={value}
        options={users}
        handleUserChange={this.handleUserChange}
        userEmail={currentUserEmail}
      />
    )
  }

  onTableCellClick = (row) => {
    if(!row) return
    const { projectUUID, lineItemUUID } = row;
    const url = nav.PROJECTS_ROUTE + '/' + projectUUID + '/lineItem/' + lineItemUUID;
    this.setState({selectedRow: row})
    nav.routeTo(url, this.props);
  } 
  
  handleUserChange(value, lineItemUUID) {
    const { limit, offset, filter } = this.props;
    const { sortField, sortOrder } = this.state;
    const type = value === 'unassign' ? "unassign" : "assign"
    const assignVal = value === 'unassign' || value === 'assignme' ? '' : value
    let qaState =''
    if (filter.selectedState === 'LAUNCHED,AWAITING_APPROVAL') {
      qaState='PRE_APPROVE,PRE_APPROVED,POST_APPROVED'
    }
    this.props.actions.updateAssignedUser(
      lineItemUUID, 
      {assignedTo: assignVal}, 
      type, 
      {qaState: qaState, state: filter.selectedState, sort: `${sortField}:${sortOrder === 'ascend' ? 'asc' : 'desc'}`, offset, limit}
    )
  }

  getPagination() {
    const { limit, total } = this.props;
    return {
      onShowSizeChange: () => this.onPageSizeChange,
      total: total,
      size: 'small',
      limit,
    };
  }

  getColumnsForFiltering = () => {
    const { columns } = this.state;
    const filter = columns.filter(column => column.key !== 'status');

    const columnsForFilter = [
      {
        title: 'Project Id',
        dataIndex: 'extProjectId',
        key: '',
        width: 0,
        render: <React.Fragment />
      },
      {
        title: 'Line Item Id',
        dataIndex: 'extLineItemId',
        key: '',
        width: 0,
        render: <React.Fragment />
      },
      ...filter,
    ];

    return columnsForFilter;
  };

  render() {
    const { lineitems, isFetching, viewState, errMessage, limit, offset, users} = this.props;
    const errorMsg = viewState === "SERVER_ERROR" ? Toast.GetErrorNotif(errMessage) : null
    const pagination = this.getPagination();
    const { sortField, sortOrder } = this.state;

    return (
      <div className='wrapper'>
        {errorMsg}
        <Filter 
          columns={this.getColumnsForFiltering()}
          limit={limit}
          offset={offset}
          sort={`${sortField}:${sortOrder === 'ascend' ? 'asc' : 'desc'}`}
          users={users}
          /> 
        <Table 
          className='lineitems'
          dataSource={lineitems}
          columns={this.state.columns}
          loading={isFetching}
          onChange={this.onPageChange}
          pagination={pagination}
        />
      </div>
    );
  }
}

export default Lineitems